import React, { useState, useEffect } from "react";
import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Education from "./components/About/Education";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import Hackathons from "./components/Hackathons/Hackathons";
import ExtraCurricular from "./components/About/ExtraCurricular";
import BeyondTech from "./components/About/BeyondTech";
import {
  BrowserRouter as Router
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import CustomCursor from "./components/CustomCursor";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <CustomCursor />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Home />
        <About />
        <Education />
        <Projects />
        <Hackathons />
        <ExtraCurricular />
        <BeyondTech />
        <Resume />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
